import styled from 'styled-components';

export const CloseIcon = styled.img`
  width: 14px;
  align-self: flex-end;
  cursor: pointer;
`;

export const HeaderLine = styled.div`
  content: '';
  flex: 1;
  height: 1px;
  background-color: #4948ac;
  align-self: center;
`;

export const SecurityHeading = styled.div`
  margin: 0px 10px 10px 0px;
  display: block;
  font-size: 24px;
  font-weight: bold;
`;

export const SecurityForm = styled.form`
  display: flex;
  flex: 1;
  padding: 20px 40px 0px 40px;
  flex-wrap: wrap;
  width: 100%;
  gap: 10px;
  justify-content: center;
`;

export const FormInputWrapper = styled.div`
  width: 100%;
  max-height: 90px;
  input {
    border: 1px solid #707070;
    border-radius: 5px;
    opacity: 1;
  }
  input: disabled {
    border: 1px solid #707070;
    border-radius: 5px;
    background: #f0f0f0 0% 0% no-repeat padding-box;
  }
  label {
    font: normal normal normal 18px/24px Biotif;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
  }
  p {
    margin: 5px;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding: 10px;
  width: 100%;
  button {
    width: 350px;
  }
`;
